import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor";
var wxsModules = {};
global.currentModuleId = "_42ee8cca";
global.currentSrcMode = "wx";
global.currentInject = { "moduleId": "_42ee8cca" };
/** script content **/
require("./time-picker-modal.ts?ctorType=component&index=0&isComponent&lang=ts&mpx&outputPath=components%2Findex42ee8cca%2Findex&resourcePath=%2Fhome%2Frunner%2Fwork%2Fmpx-cube-ui%2Fmpx-cube-ui%2Fpackages%2Fmpx-cube-ui%2Fsrc%2Fcomponents%2Ftime-picker-modal%2Findex.mpx&type=script");
export default processComponentOption({
    option: global.__mpxOptionsMap["_42ee8cca"],
    ctorType: "component",
    outputPath: "components/index42ee8cca/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: { 'cube-picker-modal-base': getComponent(require("../picker-modal/picker-modal-base.mpx?isComponent&outputPath=components%2Fpicker-modal-base6c849b9a%2Findex")), 'cube-time-picker': getComponent(require("../time-picker/index.mpx?isComponent&outputPath=components%2Findex057b2bbb%2Findex")) },
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
});
